define('modules/lp_integration/index',['require','exports','module','base/router','lib/util','./models/page','./collections/variant_collection','common/views/dashboard_layout','common/views/404','./views/main'],function (require, exports, module) {
  "use strict";

  var Router = require("base/router"),
      util = require("lib/util"),
      PageModel = require("./models/page"),
      VariantCollection = require("./collections/variant_collection"),
      DashboardLayout = require("common/views/dashboard_layout"),
      View404 = require("common/views/404"),
      PageView = require("./views/main");

  module.exports = function (moduleManager) {
    var ModuleRouter = Router.extend({
      routes: {
        "integration/:id": "index"
      },

      activatePagesTab: function (next) {
        $(".ed-navlink.active").removeClass("active");
        $(".js-pages").addClass("active");
      },

      index: function (id) {
        var pageModel = new PageModel({id: id}),
            layout = moduleManager.showInstance(DashboardLayout, { hideTitle: true }),
            pageView = new PageView({
              model: pageModel
            });

        this.activatePagesTab();
        layout.$top.close();
        layout.showLoading();
        pageModel.fetch({
          success: function () {
            layout.$content.show(pageView);
          },
          error: function () {
            layout.$content.show(new View404());
          }
        });
      }

    });
    return new ModuleRouter();
  };
});

